import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "blackListCustomer",
  tabindex: "-1",
  "aria-labelledby": "varyingModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "btn-close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Annuler ", -1)
const _hoisted_10 = ["data-bs-dismiss", "disabled"]
const _hoisted_11 = {
  class: "modal fade",
  id: "addcustomer",
  tabindex: "-1",
  "aria-labelledby": "varyingModalLabel",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "modal-dialog" }
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = { class: "modal-header" }
const _hoisted_15 = {
  key: 0,
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_16 = {
  key: 1,
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "btn-close"
}, null, -1)
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Annuler ", -1)
const _hoisted_21 = ["data-bs-dismiss", "disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", { src: "" }),
  /*#__PURE__*/_createElementVNode("p", null, "Votre commande est en cours de création, veuillez patienter...")
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "tf__cart_view"
}
const _hoisted_25 = { class: "container" }
const _hoisted_26 = { class: "link-title" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "liv-categories-products mb_30 mt_30" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Veuillez confirmer votre commande ")
  ])
], -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = {
  class: "col-xl-7 col-lg-7 wow",
  "data-wow-duration": "1s"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-xl-12 mb_40" }
const _hoisted_32 = { class: "box_booking overflow-unset" }
const _hoisted_33 = { class: "main" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "row mt_10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb_30" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Veuillez choisissez le mode de livraison")
    ])
  ])
], -1)
const _hoisted_35 = { class: "row mb_20" }
const _hoisted_36 = { class: "col-4" }
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = {
  class: "form-check-label",
  for: "cac"
}
const _hoisted_39 = { class: "icon mt_2" }
const _hoisted_40 = { class: "col-4" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = {
  class: "form-check-label",
  for: "at_place"
}
const _hoisted_43 = { class: "icon mt_2" }
const _hoisted_44 = { class: "col-4" }
const _hoisted_45 = { class: "form-check" }
const _hoisted_46 = {
  class: "form-check-label",
  for: "liv"
}
const _hoisted_47 = { class: "icon mt_2" }
const _hoisted_48 = {
  key: 0,
  class: "col-xl-12 mb_40"
}
const _hoisted_49 = { class: "box_booking overflow-unset" }
const _hoisted_50 = { class: "main" }
const _hoisted_51 = { class: "row mt_10" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 mb_30" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Client de restaurant")
  ])
], -1)
const _hoisted_53 = {
  class: "col-xl-4 col-lg-4 col-sm-4",
  style: {"text-align":"right"}
}
const _hoisted_54 = { class: "row mb_20" }
const _hoisted_55 = { class: "col-md-12 mb_20" }
const _hoisted_56 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_57 = { class: "mb_0 alert-store alert d-flex justify-content-between alert-danger" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("strong", null, "Ce client est déjà sur la liste noire", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_61 = { class: "mb_0 alert-store alert d-flex justify-content-between alert-success" }
const _hoisted_62 = {
  key: 1,
  class: "col-xl-12 mb_40"
}
const _hoisted_63 = { class: "box_booking tf__checkout_form" }
const _hoisted_64 = { class: "tf__check_form" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h5", { class: "mb_30" }, "Adresse Emporter", -1)
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-lg-12" }
const _hoisted_68 = { class: "tf__menu_search" }
const _hoisted_69 = { class: "select_area" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Selectionner l'adresse de collect", -1)
const _hoisted_71 = ["value"]
const _hoisted_72 = { class: "col-xl-12 mb_40" }
const _hoisted_73 = {
  key: 0,
  class: "box_booking overflow-unset"
}
const _hoisted_74 = { class: "main" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "row mt_10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb_30" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Veuillez planifier votre commande")
    ])
  ])
], -1)
const _hoisted_76 = {
  key: 0,
  class: "row mb_20"
}
const _hoisted_77 = { class: "col-6" }
const _hoisted_78 = { class: "form-check" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "now"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon mt_2" }, "Maintenant")
], -1)
const _hoisted_80 = { class: "col-6" }
const _hoisted_81 = { class: "form-check" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "planified"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon mt_2" }, "Planifié")
], -1)
const _hoisted_83 = {
  key: 1,
  class: "row"
}
const _hoisted_84 = { class: "col-md-12" }
const _hoisted_85 = { class: "dropdown day" }
const _hoisted_86 = { id: "selected_day" }
const _hoisted_87 = { class: "dropdown-menu-content" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h4", { class: "mt_20 mb_20" }, "Quel jour:", -1)
const _hoisted_89 = { class: "radio_select chose_day" }
const _hoisted_90 = ["onClick", "id", "value"]
const _hoisted_91 = ["for"]
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { class: "dropdown time" }
const _hoisted_95 = { id: "selected_time" }
const _hoisted_96 = { class: "dropdown-menu-content" }
const _hoisted_97 = { class: "radio_select add_bottom_15" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = ["onClick", "id", "value"]
const _hoisted_100 = ["for"]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("em", null, null, -1)
const _hoisted_102 = { key: 1 }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("li", null, "Selection la date", -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = { class: "col-xl-12 mb_40" }
const _hoisted_106 = { class: "box_booking overflow-unset" }
const _hoisted_107 = { class: "main" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb_30" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Votre commentaire"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createElementVNode("em", null, "(optionnel)")
    ])
  ])
], -1)
const _hoisted_110 = { class: "col-md-12" }
const _hoisted_111 = { class: "col-xl-12 mb_40" }
const _hoisted_112 = { class: "box_booking" }
const _hoisted_113 = { class: "main" }
const _hoisted_114 = { class: "row" }
const _hoisted_115 = {
  key: 0,
  class: "col-xl-12 mb_40"
}
const _hoisted_116 = { class: "row" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, " Valider votre commande")
], -1)
const _hoisted_118 = { class: "col-md-12 mt_35" }
const _hoisted_119 = { class: "col-xl-5 col-lg-5 wow" }
const _hoisted_120 = {
  id: "sticky_sidebar",
  class: "tf__cart_list_footer_button top-20 ssticky-top cart"
}
const _hoisted_121 = { class: "tf__cart_list_footer_button_text" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("h6", null, "Récapitulatif de la commande", -1)
const _hoisted_123 = {
  key: 0,
  class: "text-end"
}
const _hoisted_124 = {
  key: 1,
  class: "text-end"
}
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { class: "text-end" }
const _hoisted_127 = {
  key: 0,
  class: "text-end"
}
const _hoisted_128 = {
  key: 1,
  class: "text-end"
}
const _hoisted_129 = {
  key: 2,
  class: "text-end"
}
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "text-end" }
const _hoisted_132 = { key: 2 }
const _hoisted_133 = { class: "text-end" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_135 = { class: "text-end" }
const _hoisted_136 = { key: 3 }
const _hoisted_137 = { class: "text-end" }
const _hoisted_138 = { key: 4 }
const _hoisted_139 = { class: "text-end" }
const _hoisted_140 = { key: 5 }
const _hoisted_141 = { class: "text-end" }
const _hoisted_142 = { key: 6 }
const _hoisted_143 = { class: "text-end" }
const _hoisted_144 = {
  key: 7,
  class: "total"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", null, "Total Discount:", -1)
const _hoisted_146 = { class: "text-end" }
const _hoisted_147 = { class: "total" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("span", null, "Total:", -1)
const _hoisted_149 = { class: "text-end" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Vous avez un code promo ?")
], -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Appliquer", -1)
const _hoisted_153 = { class: "row justify-content-center wow" }
const _hoisted_154 = { class: "col-md-12" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("h4", { class: "title mb-4 text-center" }, "Sélectionner une table", -1)
const _hoisted_156 = { class: "list-tables" }
const _hoisted_157 = ["onClick"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/images/dinner-table.png",
  style: {"width":"50px","height":"auto","margin":"0 auto","filter":"invert(100%)"}
}, null, -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("em", { style: {"color":"red"} }, "Choix de la table est obligatoire *")
  ])
], -1)

import { ref, onMounted, computed, watch } from "vue";
import i18n from "@/i18n/index"
import SearchingField from "@/components/forms/SearchingField.vue";
import { CustomerStoreService } from "@/services/customer/customerStore.service.ts";
import { CustomerStoreRequest } from "@/services/customer/customerStore.interface.ts";
import { useVuelidate } from "@vuelidate/core";
import { required, email, minLength, maxLength, helpers, numeric } from "@vuelidate/validators";
import CustomInput from "@/components/inputsValidation/ReusableInput.vue";
import CustomerBlackListField from "@/components/forms/CustomerBlackListField.vue";
import GoogleAddressFiled from "@/components/forms/GoogleAddress.vue";
import PhoneField from "@/components/inputsValidation/PhoneField.vue";

import store from '@/store';

// @ts-nocheck
import { mapActions, mapState, mapMutations, Store, mapGetters } from "vuex";
import StoreUtils from '@/utils/StoreUtils';
import ProductUtils from '@/utils/ProductUtils';
import CheckoutUtils from '@/utils/CheckoutUtils';
import PlanifiedUtils from "@/utils/PlanifiedUtils";
import DiscountUtils from "@/utils/DiscountUtils";
import Multiselect from "@vueform/multiselect";

import Swal from 'sweetalert2';
import router from "@/router/index";

//import AddAddressComponent from "../deliveries/Add.vue";
//import EditAddressComponent from "../deliveries/Edit.vue";

import dayjs from 'dayjs'



const __default__ = {
    components: {
        //AddAddressComponent,
        //EditAddressComponent,
        Multiselect
    },
    data() {
        return {
            /**Delivery address */
            // isListDeliveryOpen: false,
            // indexOfSelectedDelivery: -1,
            /**Cac addresse */
            isListCACOpen: false,
            cacSelected: {},
            /**planified */
            show_date: false,
            show_time: false,
            times: [],
            planifiedDay: null,
            planifiedTime: null,
            listDays: [],
            deliveryType: "",
            currentDate: dayjs().format('YYYY-MM-DD'),
            /**coupon_code */
            coupon_code: null,
            /**end coupon code */
            /**Payement */
            stripe: null,
            cardToken: "",
            elements: null,
            card: undefined,
            error: false,
            /**end payement */
            loader: false,
            /** table */
            isModalTableOpen: false
        };
    },
    async mounted() {
        // @ts-ignore
        await this.fetchtDetailsStore()
        this.getLocalPanier();
        // let result = CheckoutUtils.checkIsAllGoodToOrder();
        // @ts-ignore
        if (this.cartStore?.products.length <= 0) { //|| !result
            ////console.log("return to products page")
            window.location.href = "/produits"
        } else {
            // @ts-ignore
            this.checkout.planified.isRequired = CheckoutUtils.isRequiredToPlanified();
            // @ts-ignore
            this.checkout.planified.isPlanified = this.checkout.planified.isRequired;
            // @ts-ignore
            this.checkout.isPayementAtCheckout = true // this.checkout.planified.isRequired;
            // @ts-ignore
            this.checkout.type = this.cartStore?.deliveryMode;
            // @ts-ignore
            this.checkout.table = this.cartStore?.table;
            /**Loyalty card */
            //await this.getLoyaltyCard();
            DiscountUtils.ReCalculateAllDiscounts();

            /**Delivery addresses */
            if (this.cartStore?.deliveryMode == 'liv') {
                /***Check default address if delivery mode is LIV */
                this.checkout.liv = this.SelectedCustomerStore?.address || {}
            }
            /**end Delivery addresses */
            /**cac addresses */
            // @ts-ignore
            if (this.cartStore?.deliveryMode == 'cac') {
                // @ts-ignore
                await this.getCacAddresses()
                // @ts-ignore
                if (this.storeData?.cacAddresses.length > 0) {
                    // @ts-ignore
                    this.cacSelected = this.storeData?.cacAddresses[0];
                    // @ts-ignore
                    this.checkout.cac = this.cacSelected;
                }
            }
            /*end cac addresses  */
            /**at place */
            // @ts-ignore
            if (this.cartStore?.deliveryMode == 'at_place' && !this.cartStore?.table?.id) {
                // @ts-ignore
                this.isModalTableOpen = true
                document.body.classList.add('modal-open');
                // @ts-ignore
                await this.getTables()
            }
            /**end at palce*/

            /**Planified */
            /**Get list days */
            // @ts-ignore
            this.deliveryType = this.cartStore?.deliveryMode
            this.listDays = this.storeData?.data?.opening_hours[this.deliveryType]?.dayToPlanified;
            /**end planified */
            // this.checkStripe();
            /** end stripe element */

            ////console.log(this.cartStore)
            this.getCustomersStore()
        }
    },
    methods: {
        ...mapActions(['getLocalPanier', 'getLoyaltyCard', 'getDeliveriesAddresses', 'getCacAddresses', 'checkCouponCode', 'createOrder', 'getTables', "fetchtDetailsStore", "getCustomersStore"]),
        /**Delivery address */
        openListDelivery() {
            // @ts-ignore
            this.isListDeliveryOpen = !this.isListDeliveryOpen;
        },
        selectDelivery(value, index) {
            // @ts-ignore
            this.checkout.liv = {};
            // @ts-ignore
            this.indexOfSelectedDelivery = index;
            // @ts-ignore
            this.checkout.liv = value;
        },
        /**end delivery address */
        /** cac addresses */
        openListCAC() {
            // @ts-ignore
            this.isListCACOpen = !this.isListCACOpen;
        },
        /**
         * Functions
         */
        selectCAC(event) {
            // @ts-ignore
            this.cacSelected = JSON.parse(event.target.value)
            // @ts-ignore 
            //console.log(this.cacSelected)
            this.checkout.cac = this.cacSelected;
        },
        /**end cac addresses */

        /**planified */
        ShowDate() {
            // @ts-ignore
            this.show_date = !this.show_date;
            // @ts-ignore
            this.show_time = false;
        },
        ShowHour() {
            // @ts-ignore
            this.show_time = !this.show_time;
            // @ts-ignore
            this.show_date = false;
        },

        selectDay(date, indexD) {
            if (date?.status == true) {
                this.planifiedDay = date?.date;
                this.times = this.listDays[indexD]?.times
                this.show_date = false;
                this.ShowHour();
                this.checkout.planified.planifiedAt = null
                this.planifiedTime = null
            }
        },
        selectTime(time) {
            this.show_date = false;
            this.show_time = false;
            this.planifiedTime = time;
            this.checkout.planified.planifiedAt = dayjs(
                new Date(this.planifiedDay + " " + this.planifiedTime)
            ).format("YYYY-MM-DD HH:mm");
            this.checkout.planified.isPlanified = true;
        },
        /**Coupond code */
        async applyCouponCode() {
            let data = { coupon_code: this.coupon_code, subTotal: this.cartStore.subTotal }
            await this.checkCouponCode(data);
            DiscountUtils.ReCalculateAllDiscounts();
        },
        /**end coupon code */
        /**Payement */
        /** Stripe element */
        // async checkStripe() {
        //     try {
        //         await this.stripeStatus();
        //         if (this.storeData?.stripe_status?.stripe_status == 1) {
        //             if (this.storeData.stripe_status.stripe_pk) {
        //                 this.stripe = Stripe(this.storeData.stripe_status.stripe_pk);
        //                 this.elements = this.stripe.elements();
        //                 this.card = this.elements.getElement("card");
        //                 if (this.card == "null" || this.card == null || this.card == undefined) {
        //                     this.card = this.elements.create(
        //                         "card",
        //                         { hidePostalCode: true },
        //                         { iconStyle: "solid" }
        //                     );
        //                     this.card.mount("#card-element");
        //                 } else {
        //                     this.card.mount("#card-element");
        //                 }
        //             } else {
        //             }
        //         } else {
        //         }
        //     } catch (error) {
        //         ////console.log(error);
        //     }
        // },
        async purchase() {
            let self = this
            const is_paid = await self.stripe?.createToken(self.card).then(function (result) {
                if (result.error) {
                    //hasCardErrors = true;
                    //$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                    self.error = result.error.message;
                    return false;
                } else if (typeof result.token != "undefined") {
                    self.error = false;
                    //hasCardErrors = false;
                    let stripe_status = self.storeData?.stripe_status?.stripe_status;
                    ////console.log(stripe_status)
                    self.cardToken = result.token;
                    ////console.log(self.cardToken)
                    if (stripe_status && self.cardToken) {
                        self.checkout.cardToken = self.cardToken?.id;
                        self.checkout.isPaymentCard = self.cardToken?.id ? true : false;
                        self.checkout.isPayementAtCheckout = false;
                        ////console.log(self.checkout)
                        self.prepareOrder();
                    }
                    return true;
                }
            });
            return is_paid;
            // }
        },

        async prepareOrder() {
            let Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            })

            this.loader = true;
            let error = CheckoutUtils.verifyFields();
            if (error) {
                Toast.fire({
                    icon: 'error',
                    title: error,

                });
                this.loader = false;
            }
            if (this.cartStore?.products?.length > 0 && error == "") {
                let order = CheckoutUtils.preparCheckout(this.cartStore);
                await this.createOrder(order);
                this.loader = false;
            } else {
                this.loader = false;
            }
        },
        /**end payement */

        /*** change mode liv */
        async filterByDeliveryMode(mode) {
            let switchToDeliveryMode = true
            /** First check if cart has products not avaliable on the mode selected */
            let productsToDelete = ProductUtils.CheckingAvailabilityProducts(
                this.cartStore?.products,
                mode
            );

            /**If array productsToDelete has products delete them first before switch to delivery mode selected */
            if (productsToDelete?.length > 0) {
                let sweetOption = {
                    title: this.$t("alerts.productsToDelete.title"),
                    text: this.$t("alerts.productsToDelete.text"),
                    icon: 'icon',
                    alertButtons: [
                        { text: this.$t("button.yes"), action: 'confirm', color: "confirmColor" },
                        { text: this.$t("button.no"), action: 'cancel', color: "cancleColor" },
                    ],
                }
                const selectedAction = await this.$refs.dialogConfirmation.open(sweetOption);
                if (selectedAction == "confirm") {
                    this.cartStore.products = this.cartStore?.products.filter(product => !productsToDelete.includes(product));
                    // re-calculate total
                    this.cartStore.subTotal = this.cartStore?.products.reduce(
                        (sum, product) => sum + product.total,
                        0
                    );
                    switchToDeliveryMode = true
                    Toast.fire({
                        icon: 'success',
                        title: 'Certains produits a été retiré dans votre panier', // Customize the title as needed

                    });
                } else {
                    switchToDeliveryMode = false
                }
            }
            /* if switchToDeliveryMode = false, we don't neeed to swtich the delivery mode */
            if (switchToDeliveryMode) {

                let fees = this.storeData?.data?.feeses[0]?.price || 0;
                let deliveryTotal = mode == "liv" ? fees : 0;
                this.cartStore.deliveryMode = mode;
                this.cartStore.deliveryTotal = deliveryTotal;
                this.cartStore.table = {};
                /** Check if customer can make an order**/
                this.$store.state.storeData['isOpenToOrder'] = StoreUtils.isCustomerCanPlaceOrder();
                /**Check if products has promo */
                DiscountUtils.isProductOnPromotion()
                /**Re-calculate total for all discounts */
                DiscountUtils.ReCalculateAllDiscounts();
                /** After changing delivery mode, change it on localstorage with fees  */
                localStorage?.setItem("cart", JSON.stringify(this.cartStore));
                window.location.reload()
            }
        },
        /**end mode liv */
        /** Select table when mode is at_palce */
        selectTable(table) {
            if (table?.id) {
                this.cartStore.table = { id: table?.id, table_number: table?.table_number };
                localStorage?.setItem("cart", JSON.stringify(this.cartStore));
                document.body.classList.remove('modal-open');
                this.isModalTableOpen = false
                window.location.reload()
            }
        },
        closeModalTable() {
            this.$emit("toggleSelectTable", false);
            this.isModalTableOpen = false
        },
        /**end tables */
    },
    async created() {

    },
    computed: {
        ...mapGetters(['getCartStore']),
        ...mapState(['cartStore', 'storeData', 'checkout', "detailsOrder", "customersStore", "SelectedCustomerStore"]),
        getUID() {
            //console.log(this.otherUserPage);
            return router.currentRoute.value.params.UserUUID;
        },
    }
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'index',
  setup(__props) {

const userUUID = router.currentRoute.value.params.UserUUID;
const {
    CustomerStoreState,
    getCustomerStore,
    getCustomerStoreBlacklist,
    addCustomerStore,
    updateCustomerStore,
    blacklistCustomerStore,
    removeCustomerStore,
} = CustomerStoreService(userUUID);
const loading = ref(true);
const keyword = ref("");
const srcFile = ref("");
const add = ref(true);
const buttonValid = ref(false);
const selectedCustomerID = ref(null);
const customerFound = ref(null);
const isNumberValid = ref(false);
const customerFoundIsEnabled = ref(false);
const CustomerStore = ref<CustomerStoreRequest>({
    id: null,
    firstName: "",
    lastName: "",
    address: "",
    phone: "",
    motif: null,
    isEnabled: 1,
    googleAddress: {}

});


const validNumber = (isValid: boolean) => {
    isNumberValid.value = isValid;
};

const CheckIsPhoneNumberValid = (value, vm) => {
    return isNumberValid.value;
};


const rules = {
    firstName: { required: helpers.withMessage(i18n.t("validator.required"), required), String },
    // lastName: { required: helpers.withMessage(i18n.t("validator.required"), required), String },
    //address: { required: helpers.withMessage(i18n.t("validator.required"), required), String },
    phone: {
        required: helpers.withMessage(i18n.t("validator.required"), required),
        CheckIsPhoneNumberValid: helpers.withMessage(i18n.t("validator.phone"), CheckIsPhoneNumberValid),
    },
    googleAddress: {
        address: {
            required: helpers.withMessage(i18n.t("validator.required"), required)
        }
    },
};
const v$ = useVuelidate(rules, CustomerStore);
onMounted(async () => {
    await getCustomerStore();
    loading.value = false;
});


const getRole = (id) => {
    return store.getters['auth/role']
}
const emptyState = () => {
    add.value = true;
    if (!v$.value.$invalid) {
        buttonValid.value = true;
    } else {
        buttonValid.value = false;
    }
    CustomerStore.value.id = null;
    CustomerStore.value.firstName = "";
    CustomerStore.value.lastName = "";
    CustomerStore.value.address = "";
    CustomerStore.value.phone = "";
    CustomerStore.value.motif = null;
    CustomerStore.value.isEnabled = 1;
    customerFoundIsEnabled.value = false
    selectedCustomerID.value = null
    if (CustomerStore?.value?.googleAddress)
        CustomerStore.value.googleAddress["address"] = null
    v$.value.$reset();
};

const createCustomerStore = async () => {
    await v$.value.$validate();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        CustomerStore.value.address = CustomerStore.value.googleAddress.address
        if (add.value) {
            await addCustomerStore(CustomerStore.value);
            emptyState();
            await getCustomerStore();
            store.state.SelectedCustomerStore = CustomerStoreState?.data[CustomerStoreState?.data?.length - 1] ?? null
            store.state.checkout.liv = store.state.SelectedCustomerStore?.address || {}
        } else {
            await updateCustomerStore(CustomerStore.value);
            await getCustomerStore();
            store.state.SelectedCustomerStore = CustomerStoreState?.data?.find(customer => customer.id === selectedCustomerID.value) ?? null
            store.state.checkout.liv = store.state.SelectedCustomerStore?.address || {}
        }
        customerFoundIsEnabled.value = store.state.SelectedCustomerStore?.isEnabled
        selectedCustomerID.value = store.state.SelectedCustomerStore?.id
        buttonValid.value = false;
    } else {
        buttonValid.value = true;
    }
};

const unblacklisterCustomerStore = (customer: CustomerStoreRequest) => {
    Swal.fire({
        title: "Etes-vous sûr ?",
        text: "Ce client sera supprimé de la liste noire",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, Supprimer",
        cancelButtonText: "Annuler",
    }).then(async (result) => {
        if (result.isConfirmed) {
            CustomerStore.value.id = customer.id;
            CustomerStore.value.motif = null
            CustomerStore.value.isEnabled = 1;
            await blacklistCustomerStore(CustomerStore.value);
            await getCustomerStore();
            changeInput()
        }
    });
};

const updateState = (customer: CustomerStoreRequest) => {
    add.value = false;
    if (!v$.value.$invalid) {
        buttonValid.value = true;
    } else {
        buttonValid.value = false;
    }
    CustomerStore.value.id = customer.id;
    CustomerStore.value.firstName = customer.firstName;
    CustomerStore.value.lastName = customer.lastName;
    CustomerStore.value.address = customer.address;
    CustomerStore.value.phone = customer.phone;
    CustomerStore.value.motif = !customer.isEnabled ? null : customer.motif;
    CustomerStore.value.isEnabled = customer.isEnabled;
    CustomerStore.value.googleAddress.address = customer.address ? customer.address : ""

    v$.value.$reset();
};

const changeInput = () => {
    store.state.SelectedCustomerStore = CustomerStoreState?.data?.find(customer => customer.id === selectedCustomerID.value) ?? null
    customerFoundIsEnabled.value = store.state.SelectedCustomerStore?.isEnabled
    if (store.state.cartStore?.deliveryMode == 'liv') {
        store.state.checkout.liv = store.state.SelectedCustomerStore?.address || {}
    }
    let Toast = Swal.mixin({
        toast: true,
        position: 'top-right',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
    })
    if (!CustomerStore.value || !customerFoundIsEnabled.value) {
        Toast.fire({
            icon: 'error',
            title: "Ce client est déjà sur la liste noire",

        });
    }
}


watch(selectedCustomerID, () => {
    if (selectedCustomerID.value == null) {
        store.state.SelectedCustomerStore = null
        customerFoundIsEnabled.value = false
    }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CustomModal = _resolveComponent("CustomModal")!
  const _component_dialog_confirmation = _resolveComponent("dialog-confirmation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (CustomerStore.value.id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_5, " blacklister ce client [ " + _toDisplayString(CustomerStore.value?.firstName + ' ' + CustomerStore.value?.lastName) + " ] ", 1))
              : _createCommentVNode("", true),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", null, [
              _createVNode(CustomInput, {
                modelValue: CustomerStore.value.motif,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((CustomerStore.value.motif) = $event)),
                label: "customerStore.motif",
                v: _unref(v$).motif
              }, null, 8, ["modelValue", "v"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": _unref(v$).$invalid ? '' : 'modal',
              disabled: _unref(v$).$invalid && buttonValid.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addCustomerStoreOnblackList()))
            }, _toDisplayString(CustomerStore.value.id ? "Modifier" : "Ajouter"), 9, _hoisted_10)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (CustomerStore.value.id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_15, " Modifier ce client "))
              : _createCommentVNode("", true),
            (!CustomerStore.value.id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_16, " Ajouter un nouveau client "))
              : _createCommentVNode("", true),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", null, [
              _createVNode(CustomInput, {
                modelValue: CustomerStore.value.lastName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((CustomerStore.value.lastName) = $event)),
                label: "customerStore.lastName",
                v: _unref(v$).lastName
              }, null, 8, ["modelValue", "v"]),
              _createVNode(CustomInput, {
                modelValue: CustomerStore.value.firstName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((CustomerStore.value.firstName) = $event)),
                label: "customerStore.firstName",
                v: _unref(v$).firstName
              }, null, 8, ["modelValue", "v"]),
              _createVNode(PhoneField, {
                modelValue: CustomerStore.value.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((CustomerStore.value.phone) = $event)),
                onValidNumber: validNumber,
                label: "customerStore.phone",
                v: _unref(v$).phone
              }, null, 8, ["modelValue", "v"]),
              _createVNode(GoogleAddressFiled, {
                modelValue: CustomerStore.value.googleAddress,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((CustomerStore.value.googleAddress) = $event)),
                address: CustomerStore.value.address,
                validattion: _unref(v$).googleAddress,
                label: "customerStore.address"
              }, null, 8, ["modelValue", "address", "validattion"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": _unref(v$).$invalid ? '' : 'modal',
              disabled: _unref(v$).$invalid && buttonValid.value,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (createCustomerStore()))
            }, _toDisplayString(CustomerStore.value.id ? "Modifier" : "Ajouter"), 9, _hoisted_21)
          ])
        ])
      ])
    ]),
    (_ctx.loader)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ checkout_loader: _ctx.loader })
        }, _hoisted_23, 2))
      : _createCommentVNode("", true),
    (_ctx.cartStore?.products)
      ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: { name: 'AddToCart', params: { UserUUID: _ctx.getUID } },
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", _hoisted_26, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "store",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createTextVNode("Retour à la page produits")
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _withDirectives(_createElementVNode("input", {
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterByDeliveryMode('cac'))),
                                class: "form-check-input",
                                type: "radio",
                                id: "cac",
                                name: "deliveryMode",
                                value: "cac",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cartStore.deliveryMode) = $event))
                              }, null, 544), [
                                [_vModelRadio, _ctx.cartStore.deliveryMode]
                              ]),
                              _createElementVNode("label", _hoisted_38, [
                                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('store.activity.CandC')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _withDirectives(_createElementVNode("input", {
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filterByDeliveryMode('at_place'))),
                                class: "form-check-input",
                                type: "radio",
                                id: "at_place",
                                name: "deliveryMode",
                                value: "at_place",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cartStore.deliveryMode) = $event))
                              }, null, 544), [
                                [_vModelRadio, _ctx.cartStore.deliveryMode]
                              ]),
                              _createElementVNode("label", _hoisted_42, [
                                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('store.activity.atPlace')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _withDirectives(_createElementVNode("input", {
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterByDeliveryMode('liv'))),
                                class: "form-check-input",
                                type: "radio",
                                id: "liv",
                                name: "deliveryMode",
                                value: "liv",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cartStore.deliveryMode) = $event))
                              }, null, 544), [
                                [_vModelRadio, _ctx.cartStore.deliveryMode]
                              ]),
                              _createElementVNode("label", _hoisted_46, [
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('store.activity.delivery')), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_unref(CustomerStoreState)?.data)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("button", {
                                  type: "button",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#addcustomer",
                                  "data-bs-whatever": "@mdo",
                                  class: "btn btn-primary text-white",
                                  onClick: emptyState
                                }, _toDisplayString(_ctx.$t("categories.add")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_unref(Multiselect), {
                                  modelValue: selectedCustomerID.value,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedCustomerID).value = $event)),
                                  label: "phone",
                                  valueProp: "id",
                                  "track-by": "phone",
                                  placeholder: "Selectionner un client",
                                  options: _unref(CustomerStoreState)?.data,
                                  searchable: true,
                                  onSelect: changeInput
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              ((!customerFoundIsEnabled.value && selectedCustomerID.value))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", null, [
                                        _hoisted_58,
                                        _hoisted_59,
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, "Nom et prénom : " + _toDisplayString(_ctx.SelectedCustomerStore?.firstName) + ", " + _toDisplayString(_ctx.SelectedCustomerStore?.lastName), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, "Téléphone: " + _toDisplayString(_ctx.SelectedCustomerStore?.phone), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, "Adresse : " + _toDisplayString(_ctx.SelectedCustomerStore?.address), 1)
                                        ])
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-warning btn-icon",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (unblacklisterCustomerStore(_ctx.SelectedCustomerStore)))
                                      }, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "pen",
                                          size: "lg"
                                        })
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              ((customerFoundIsEnabled.value && selectedCustomerID.value))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, "Nom et prénom : " + _toDisplayString(_ctx.SelectedCustomerStore?.firstName) + ", " + _toDisplayString(_ctx.SelectedCustomerStore?.lastName), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, "Téléphone: " + _toDisplayString(_ctx.SelectedCustomerStore?.phone), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, "Adresse : " + _toDisplayString(_ctx.SelectedCustomerStore?.address), 1)
                                        ])
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-success btn-icon",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#addcustomer",
                                        "data-bs-whatever": "@mdo",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (updateState(_ctx.SelectedCustomerStore)))
                                      }, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "pen",
                                          size: "lg"
                                        })
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.cartStore?.deliveryMode == 'cac')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", {
                                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.openListCAC && _ctx.openListCAC(...args))),
                                      class: _normalizeClass(["nice-select select_js", { open: _ctx.isListCACOpen }]),
                                      tabindex: "0"
                                    }, [
                                      _hoisted_70,
                                      _createElementVNode("select", {
                                        class: "form-control list",
                                        onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectCAC($event)))
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeData?.cacAddresses, (cac, index) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            class: "option",
                                            value: JSON.stringify(cac)
                                          }, _toDisplayString(cac.address), 9, _hoisted_71))
                                        }), 256))
                                      ], 32)
                                    ], 2)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_72, [
                    (_ctx.checkout)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _hoisted_75,
                            (!_ctx.checkout.planified.isRequired)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                  _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        id: "now",
                                        name: "planified",
                                        value: false,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.checkout.planified.isPlanified) = $event))
                                      }, null, 512), [
                                        [_vModelRadio, _ctx.checkout.planified.isPlanified]
                                      ]),
                                      _hoisted_79
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("div", _hoisted_81, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        id: "planified",
                                        name: "planified",
                                        value: true,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.checkout.planified.isPlanified) = $event))
                                      }, null, 512), [
                                        [_vModelRadio, _ctx.checkout.planified.isPlanified]
                                      ]),
                                      _hoisted_82
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkout.planified.isPlanified)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("a", {
                                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.ShowDate && _ctx.ShowDate(...args))),
                                        class: _normalizeClass({ show: _ctx.show_date })
                                      }, [
                                        _createElementVNode("span", null, [
                                          _createTextVNode("Jour "),
                                          _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.planifiedDay), 1)
                                        ])
                                      ], 2),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["dropdown-menu", { show: _ctx.show_date }])
                                      }, [
                                        _createElementVNode("div", _hoisted_87, [
                                          _hoisted_88,
                                          _createElementVNode("div", _hoisted_89, [
                                            _createElementVNode("ul", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDays, (date, indexDay) => {
                                                return (_openBlock(), _createElementBlock("li", { key: _ctx.day }, [
                                                  _createElementVNode("div", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "radio",
                                                      class: _normalizeClass([{ 'disabled-date': date?.status == false }, "displaynon"]),
                                                      onClick: ($event: any) => (_ctx.selectDay(date, indexDay)),
                                                      id: `day_${indexDay}`,
                                                      name: "day",
                                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.planified_date) = $event)),
                                                      value: date?.date
                                                    }, null, 10, _hoisted_90), [
                                                      [_vModelRadio, _ctx.planified_date]
                                                    ]),
                                                    _createElementVNode("label", {
                                                      class: _normalizeClass({ 'disabled-date': date?.status == false }),
                                                      for: `day_${indexDay}`
                                                    }, [
                                                      (date?.date != _ctx.currentDate)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(date?.dayName), 1))
                                                        : _createCommentVNode("", true),
                                                      (date?.date == _ctx.currentDate)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, " Aujourd'hui "))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("em", null, _toDisplayString(date?.date), 1)
                                                    ], 10, _hoisted_91)
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ])
                                        ])
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_94, [
                                      _createElementVNode("a", {
                                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.ShowHour && _ctx.ShowHour(...args))),
                                        class: _normalizeClass({ show: _ctx.show_time })
                                      }, [
                                        _createElementVNode("span", null, [
                                          _createTextVNode("Heure "),
                                          _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.planifiedTime), 1)
                                        ])
                                      ], 2),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["dropdown-menu overflow", { show: _ctx.show_time }])
                                      }, [
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("div", _hoisted_97, [
                                            (_ctx.times?.length)
                                              ? (_openBlock(), _createElementBlock("ul", _hoisted_98, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (hour, indexT) => {
                                                    return (_openBlock(), _createElementBlock("li", null, [
                                                      _createElementVNode("input", {
                                                        type: "radio",
                                                        onClick: ($event: any) => (_ctx.selectTime(hour)),
                                                        id: `time_${indexT}`,
                                                        name: "hour",
                                                        class: "displaynon",
                                                        value: hour
                                                      }, null, 8, _hoisted_99),
                                                      _createElementVNode("label", {
                                                        for: `time_${indexT}`
                                                      }, [
                                                        _createTextVNode(_toDisplayString(hour), 1),
                                                        _hoisted_101
                                                      ], 8, _hoisted_100)
                                                    ]))
                                                  }), 256))
                                                ]))
                                              : (_openBlock(), _createElementBlock("ul", _hoisted_102, _hoisted_104))
                                          ])
                                        ])
                                      ], 2)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _hoisted_109,
                          _createElementVNode("div", _hoisted_110, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              placeholder: "Communiquez au restaurant ce dont ils doivent tenir compte",
                              rows: "4",
                              maxlength: "100",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.checkout.comment) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.checkout.comment]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("div", _hoisted_114, [
                          (_ctx.checkout.isPayementAtCheckout)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                _createElementVNode("div", _hoisted_116, [
                                  _hoisted_117,
                                  _createElementVNode("div", _hoisted_118, [
                                    _createElementVNode("button", {
                                      class: "btn_1 w-100 common_btn",
                                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.prepareOrder && _ctx.prepareOrder(...args)))
                                    }, "Valider")
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _hoisted_122,
                    _createElementVNode("p", null, [
                      _createTextVNode(" Paiement : "),
                      (_ctx.checkout?.isPayementAtCheckout)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_123, " à la caisse"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_124, "Par carte bancaire"))
                    ]),
                    (_ctx.checkout?.planified?.isPlanified &&
                                _ctx.checkout?.planified?.planifiedAt
                            )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_125, [
                          _createTextVNode(" Planifie : "),
                          _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.checkout?.planified?.planifiedAt), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, [
                      _createTextVNode(" Mode de livraison : "),
                      (_ctx.cartStore?.deliveryMode == 'liv')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_127, "Livraison"))
                        : _createCommentVNode("", true),
                      (_ctx.cartStore?.deliveryMode == 'cac' && _ctx.checkout?.cac?.id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_128, "click and collect"))
                        : _createCommentVNode("", true),
                      (_ctx.cartStore?.deliveryMode == 'at_place')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_129, "Sur place"))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.checkout?.table?.id)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_130, [
                          _createTextVNode(" Numéro de la table : "),
                          _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.checkout?.table?.table_number), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cartStore?.deliveryMode == 'cac' && _ctx.checkout?.cac?.id)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_132, [
                          _createTextVNode(" Adresse : "),
                          _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.checkout?.cac?.address), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_134,
                    _createElementVNode("p", null, [
                      _createTextVNode(" Sous-Total: "),
                      _createElementVNode("span", _hoisted_135, "€ " + _toDisplayString(_ctx.cartStore?.subTotal.toFixed(2)), 1)
                    ]),
                    (_ctx.cartStore?.deliveryMode == 'liv')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_136, [
                          _createTextVNode(" Frais de livraison: "),
                          _createElementVNode("span", _hoisted_137, "€ " + _toDisplayString(_ctx.cartStore?.deliveryTotal.toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cartStore?.discountCouponcode > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_138, [
                          _createTextVNode(" Code promo : " + _toDisplayString(_ctx.storeData?.couponCode?.code_number) + ", " + _toDisplayString(_ctx.storeData?.couponCode?.percentage) + " % ", 1),
                          _createElementVNode("span", _hoisted_139, " € -" + _toDisplayString((_ctx.cartStore?.discountCouponcode).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cartStore.discountFidelite > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_140, [
                          _createTextVNode(" Réduction carte fidélité " + _toDisplayString(_ctx.storeData?.data?.config_loyalty[0]?.percentage) + " % : ", 1),
                          _createElementVNode("span", _hoisted_141, "€ -" + _toDisplayString(_ctx.cartStore.discountFidelite.toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cartStore.discountPromotions > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_142, [
                          _createTextVNode(" discountPromotions : "),
                          _createElementVNode("span", _hoisted_143, "€ -" + _toDisplayString(_ctx.cartStore.discountPromotions.toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cartStore?.discountTotal > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_144, [
                          _hoisted_145,
                          _createElementVNode("span", _hoisted_146, "€ - " + _toDisplayString((_ctx.cartStore?.discountTotal).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_147, [
                      _hoisted_148,
                      _createElementVNode("span", _hoisted_149, "€ " + _toDisplayString((_ctx.cartStore?.totalFinal).toFixed(2)), 1)
                    ]),
                    _hoisted_150,
                    _createElementVNode("div", null, [
                      _hoisted_151,
                      _createElementVNode("form", {
                        onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyCouponCode && _ctx.applyCouponCode(...args)), ["prevent"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Coupon Code",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.coupon_code) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.coupon_code]
                        ]),
                        _hoisted_152
                      ], 32)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isModalTableOpen)
      ? (_openBlock(), _createBlock(_component_CustomModal, {
          key: 2,
          modalsize: 'modal-md'
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("div", _hoisted_154, [
                _hoisted_155,
                _createElementVNode("div", _hoisted_156, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeData?.tables, (table, indexT) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item-table",
                      onClick: ($event: any) => (_ctx.selectTable(table))
                    }, [
                      _hoisted_158,
                      _createElementVNode("p", null, _toDisplayString(table.table_number), 1)
                    ], 8, _hoisted_157))
                  }), 256))
                ])
              ]),
              _hoisted_159
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_dialog_confirmation, { ref: "dialogConfirmation" }, null, 512)
  ], 64))
}
}

})